import React, { useState, useEffect } from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';

const OfflinePopup = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  if (isOnline) return null;

  return (
    <div className="offline-popup">
      <div className="offlinepopup-content">
        <div className="icon-container">
          <WifiOff size={60} className="icon" />
        </div>
        
        <h2 className="popup-title">
          No Internet Connection
        </h2>
        
        <p className="popup-message">
          You appear to be offline. Please check your network connection and try again.
        </p>
        
        <button
          onClick={handleRefresh}
          className="refresh-button"
        >
          <RefreshCw size={18} className="button-icon" />
          Refresh Page
        </button>
      </div>
    </div>
  );
};

export default OfflinePopup;